/* GLOBAL DRAG AND DROP *******************************************************/

export const START_DRAG = 'drag-and-drop/START_DRAG'
export const startDrag = (domain, uid, opts) => {
  return { type: START_DRAG, domain, uid, opts }
}

export const STOP_DRAG = 'drag-and-drop/START_DRAG'
export const stopDrag = () => {
  return { type: STOP_DRAG }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/drag-and-drop.js